export default "__VITE_ASSET__6QCr2kGX__"